module.exports = __webpack_public_path__ + "static/media/backward_blue.75d55f13.svg";